export default __webpack_public_path__ + "static/media/18-1.7cf9935b.jpg";